export const PERMISSION_KEYS = {
  dashboard: 'quotes',
  clients: 'clients',
  quotes: 'quotes',
  quotesPreparation: 'quotes_preparation',
  quoteFix: 'quote_fix',
  visits: 'visits',
  jobAutomation: 'job_automation',
  approvedQuotes: 'approved_quotes',
  notes: 'notes',
  settings: 'settings',
  sync: 'sync',
};

export const SYNC_PERMISSION = {
  [PERMISSION_KEYS.sync]: ['update'],
};

export const ROUTE_PERMISSIONS = {
  dashboard: {
    [PERMISSION_KEYS.dashboard]: ['view'],
  },
  clients: {
    [PERMISSION_KEYS.clients]: ['view'],
  },
  quotes: {
    [PERMISSION_KEYS.quotes]: ['view'],
  },
  quotesUpdate: {
    [PERMISSION_KEYS.quotes]: ['update'],
  },
  quotesPreparation: {
    [PERMISSION_KEYS.quotesPreparation]: ['view'],
  },
  quoteFix: {
    [PERMISSION_KEYS.quoteFix]: ['view'],
  },
  visits: {
    [PERMISSION_KEYS.visits]: ['view'],
  },
  jobAutomation: {
    [PERMISSION_KEYS.jobAutomation]: ['view'],
  },
  approvedQuotes: {
    [PERMISSION_KEYS.approvedQuotes]: ['view'],
  },
  notes: {
    [PERMISSION_KEYS.notes]: ['view'],
  },
  settings: {
    [PERMISSION_KEYS.settings]: ['view'],
  },
};

export const PERMISSION_RESOURCE_ALIASES = {
  // Keep empty for strict matching: no fallback aliases.
};
